/* eslint-disable no-use-before-define */
import Constants from '../config/const';
import { saveWallApi, signWallUpload } from '../config/api';
import { automaticPreview } from '../selectors/preview';

let saving = false;
let queue = [];

const doSaveWall = (dispatch, resolve, reject) => {
  saving = true;
  dispatch({
    type: Constants.savingWall.start
  });
  const {
    wallId, wall, customImage, wallPaper,
    works, previewImageUrl, preview, transparentPreviewImageUrl
  } = queue.pop();
  queue = [];
  const updateParams = {
    wallId, wall, works
  };
  updateParams.wall.preview = preview;
  if (previewImageUrl) {
    updateParams.previewImageUrl = previewImageUrl;
  }
  if (transparentPreviewImageUrl) {
    updateParams.transparentPreviewImageUrl = transparentPreviewImageUrl;
  }
  if (customImage) {
    if (!customImage.src || customImage.src.match(/^http/)) {
      updateParams.customImage = customImage;
    }
  }
  if (wallPaper) {
    if (!wallPaper.src || wallPaper.src.match(/^http/)) {
      updateParams.wallPaper = wallPaper;
    }
  }
  saveWallApi(updateParams).then(() => {
    onWallSaved(dispatch);
    if (resolve) {
      resolve();
    }
  }).catch((error) => {
    onWallSaved(dispatch);
    if (reject) {
      reject(error);
    }
  });
};

const onWallSaved = (dispatch) => {
  saving = false;
  dispatch({
    type: Constants.savingWall.end
  });
  if (queue.length) {
    doSaveWall(dispatch);
  }
};

export const saveWall = (
  previewImageUrl, transparentPreviewImageUrl, resolve, reject
) => (dispatch, getState) => {
  const {
    canvas, customImage, wallPaper
  } = getState();
  const preview = automaticPreview(getState());
  const {
    wallId, works, currentColor, width, height, name, description,
    keywordList, colorList, associatedRoomIds, associatedHomeDecorStyleIds
  } = canvas;
  const wall = {
    wallId,
    currentColor,
    width,
    height,
    name,
    description,
    keywordList,
    colorList,
    associatedRoomIds,
    associatedHomeDecorStyleIds
  };
  const entry = {
    wallId, wall, customImage, wallPaper, works: { ...works }, preview
  };
  if (previewImageUrl) {
    entry.previewImageUrl = previewImageUrl;
  }
  if (transparentPreviewImageUrl) {
    entry.transparentPreviewImageUrl = transparentPreviewImageUrl;
  }
  queue.push(entry);
  if (!saving || resolve) {
    doSaveWall(dispatch, resolve, reject);
  }
};

const uploadSignedFile = (url, newHref, values, content) => new Promise((resolve, reject) => {
  const formData = new FormData();
  Object.entries(values).forEach(([k, v]) => {
    if (k === 'contentType') {
      formData.append('Content-Type', v);
    } else {
      formData.append(k, v);
    }
  });
  formData.append('file', content);
  window.fetch(url, {
    method: 'POST',
    body: formData
  }).then(({ status }) => {
    if (status === 204) {
      resolve(newHref);
    } else {
      alert('Error uploading file'); // eslint-disable-line no-alert
      reject();
    }
  }).catch((error) => {
    alert(`Error uploading file ${ error }`); // eslint-disable-line no-alert
    reject();
  });
});

const uploadBase64File = (url, newHref, values, base64) => new Promise((resolve) => {
  fetch(base64).then((image) => {
    image.blob().then((data) => {
      uploadSignedFile(url, newHref, values, data).then((newSrc) => {
        resolve(newSrc);
      });
    });
  });
});

export const uploadPreview = (getState, base64, transparentBase64) => new Promise((resolve) => {
  const coma = base64.indexOf(',');
  const contentType = base64.substr(0, coma).split(/:/)[1].split(/;/)[0];
  const ext = contentType.split(/\//)[1];
  const { canvas: { wallId } } = getState();

  const sign1 = signWallUpload(wallId, contentType, 'wall_previews', 'preview', ext);
  const sign2 = signWallUpload(wallId, contentType, 'wall_previews', 'preview-transparent', ext);
  Promise.all([sign1, sign2]).then((signatures) => {
    const urls = [];
    uploadBase64File(
      signatures[0].url,
      signatures[0].newHref,
      signatures[0].values,
      base64
    ).then((url) => {
      urls.push(url);
      uploadBase64File(
        signatures[1].url,
        signatures[1].newHref,
        signatures[1].values,
        transparentBase64
      ).then((transparentUrl) => {
        urls.push(transparentUrl);
        resolve(urls);
      });
    });
  });
});

export const uploadAsset = (
  dispatch, getState, src, binaryContent, prefix
) => new Promise((resolve) => {
  dispatch({
    type: Constants.savingWall.uploadAssetsStart
  });
  const coma = src.indexOf(',');
  const contentType = src.substr(0, coma).split(/:/)[1].split(/;/)[0];
  const ext = contentType.split(/\//)[1];

  const { canvas: { wallId } } = getState();
  signWallUpload(wallId, contentType, prefix, 'file', ext).then(({ url, newHref, values }) => {
    uploadSignedFile(url, newHref, values, binaryContent).then((newSrc) => {
      dispatch({
        type: Constants.savingWall.uploadAssetsEnd
      });
      resolve(newSrc);
    });
  });
});
